// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_PICTURE = "P\u0159idej fotku";
